import React from 'react';
import CheckboxField from 'components/pure/utils/form/CheckboxField';
import CoachingContentDetailScore from 'records/CoachingContentDetailScore';

export default class ContentDetailSelector extends React.PureComponent {
  add(contentDetail) {
    const {reviewFileUpload, onChange} = this.props;
    onChange(
      reviewFileUpload.set(
        'reviewFeedbackList',
        reviewFileUpload.reviewFeedbackList.push(new CoachingContentDetailScore({contentDetail}))
      )
    );
  }
  remove(contentDetail) {
    const {reviewFileUpload, onChange} = this.props;
    onChange(
      reviewFileUpload.set(
        'reviewFeedbackList',
        reviewFileUpload.reviewFeedbackList.filter(
          reviewFeedback => reviewFeedback.contentDetailId !== contentDetail.id
        )
      )
    );
  }
  render() {
    const {coachingPlan, skills, reviewFileUpload, immutable} = this.props;
    if (coachingPlan.contentDetails.size <= 1) {
      return null;
    } else {
      return (
        <div className="content-detail-selector">
          <label>Use call for review of skill(s):</label>
          {coachingPlan.contentDetails.map(detail => {
            const skill = skills.find(skill => skill.id === detail.skillId);
            const isChecked = reviewFileUpload.reviewFeedbackList.some(
              ({contentDetailId}) => contentDetailId === detail.id
            );
            return (
              <CheckboxField
                key={detail.id}
                label={skill ? skill.skill : detail.custom}
                disabled={immutable}
                checked={isChecked}
                onCheck={() => this[!isChecked ? 'add' : 'remove'](detail)}
              />
            );
          })}
        </div>
      );
    }
  }
}
